import { useForm } from "react-hook-form"
import { Link, useNavigate } from "react-router-dom"
import { formatter, guardarLocalStorage, isValidEmail, obtenerLocalStorage } from "../resources/funciones"
import { useContext, useEffect, useState } from "react"
import { CarritoContext } from "../context/CarritoContext"

import {useTranslation} from 'react-i18next'

import { getUbigeo, registrarSolicitud } from "../api/azpitia"
import { ToastContainer, toast } from 'react-toastify';

import AutoInput from './common/AutoComplete'

const tema = "colored"

const notifyError = () => toast.error('Error en el servidor', {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: tema,
});

export const DatosEnvio = () => {

    const logo = "/image/logos/LOGO1_Short.png"

    const [listaUbigeo, setListaUbigeo] = useState([])
    
    const [loading, setLoading] = useState(false)

    const datosLS = obtenerLocalStorage('cliente')
    const { t } = useTranslation()

    const { register, handleSubmit, formState: { errors }, watch, setValue } = useForm({
        defaultValues: {
            email: datosLS?.email || "",
            nombre: datosLS?.nombre || "",
            apellido: datosLS?.apellido || "",
            telefono: datosLS?.telefono || "",
            pais: datosLS?.pais || "Peru",
            ciudad: datosLS?.ciudad || "",
            direccion: datosLS?.direccion || "",
            cod_postal: datosLS?.cod_postal || "",
            depProvDis: "",
            comprobante: datosLS?.comprobante || { tipo: "", documento: "", nroDocumento: "", nombre: "", apellido: "", ruc: "", razon: "" },
        }
    })

    const { carrito, totalCarrito } = useContext(CarritoContext)
    const navigate = useNavigate()

    const onSubmitDetalles = async (data) => {
        /* console.log(data) */
        setLoading(true)

        guardarLocalStorage(data, 'cliente')

        const dataDepProvDis = data?.depProvDis || ""

        const listaProductos = carrito?.map((p) => (
            {
                ProdCod: p.ProdCod,
                Cantidad: p.Cantidad,
                ProdPack: p.ProdPack,
                Detalle: p.detalle
            }
        ))
        let departamento = "";
        let provincia = "";
        let distrito = "";

        if (dataDepProvDis !== "") {
            departamento = dataDepProvDis.split("/")[0]
            provincia = dataDepProvDis.split("/")[1]
            distrito = dataDepProvDis.split("/")[2]
        }

        const dataDetalles = {
            SolEmail: data.email.trim(),
            SolNom: data.nombre.trim().toUpperCase(),
            SolApe: data.apellido.trim().toUpperCase(),
            SolTel: data.telefono.trim(),
            SolPais: data.pais.trim().toUpperCase(),
            SolDep: departamento.toUpperCase(),
            SolProv: provincia.toUpperCase(),
            SolCiud: (distrito !== "" ? distrito.toUpperCase() : data.ciudad.trim().toUpperCase()),
            SolDire: data.direccion.trim().toUpperCase(),
            SolCodPost: data.cod_postal.trim(),
            list: listaProductos || []
        }

        const dataComprobante = {
            PagTipComp: data.comprobante.tipo,
            PagTipId: data.comprobante.documento,
            PagIdNum: data.comprobante.nroDocumento,
            PagNom: data.comprobante.nombre.trim().toUpperCase(),
            PagApe: data.comprobante.apellido.trim().toUpperCase(),
            PagRuc: data.comprobante.ruc,
            PagRazon: data.comprobante.razon.trim().toUpperCase()
        }

        const { status, token, codigo_solicitud } = await registrarSolicitud(dataDetalles)

        if (status === 1) {
            navigate("/pagar-izipay", {
                state: {
                    token,
                    dataDetalles,
                    codigo_solicitud,
                    dataComprobante
                }
            })
        } else {
            notifyError()
            setLoading(false)
        }


    }

    const handleEmailValidation = email => {
        const isValid = isValidEmail(email);
        return isValid;
    };

    const handleIdNumberValidation = (value) => {
        let isValid = true
        if (watch('comprobante').tipo === 'B') {
            if (watch('comprobante').documento === 'D') {
                isValid = !isNaN(value) && value.length === 8
            } else if (watch('comprobante').documento === 'CE') {
                isValid = !isNaN(value) && value.length === 9
            }
        } else {
            isValid = !isNaN(value) && value.length === 11
        }
        return isValid
    }

    const obtenerListaUbigeo = async () => {
        const { status, ubigeo } = await getUbigeo()

        if (status === 1) {
            
            let ubigeolista = []
            ubigeo.forEach(item => {
                ubigeolista.push(item.tipo)
            })
            setListaUbigeo(ubigeolista)
        } else {
            setListaUbigeo([])
        }
    }

    useEffect(() => {
        obtenerListaUbigeo();
    }, []);



    return (
        <div>
            {/* Navbar de compra */}
            <nav className="navbar bg-primario position-relative">
                <div className="container contenedor-logo">
                    <Link className="navbar-brand col-4 m-1 me-4" to="/inicio">
                        <img src={logo} alt="Logo Altos de Azpitia" height={60} />
                    </Link>                    
                </div>
            </nav>

            {/* Formulario de compra */}
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <form onSubmit={handleSubmit(onSubmitDetalles)} className="p-1">
                            <div className="section-header mt-4">
                                <h2>{t("compra_envio_cabecera")}</h2>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input
                                            {...register("email", { required: true, validate: handleEmailValidation })}
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                        />
                                        <label>{t("compra_envio_input_email")} <span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    {errors.email && errors.email.type === "required" && <p role="alert" className="error">{t("compra_envio_msg_email_requerido")}</p>}
                                    {errors.email && errors.email.type === "validate" && <p role="alert" className="error">{t("compra_envio_msg_email_error")}</p>}
                                </div>                                                                
                            </div>

                            <div className="row mt-2">
                                <div className="col-6">
                                    <div className="form-floating">
                                        <input
                                            {...register("nombre", { required: true })}
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                        />
                                        <label>{t("compra_envio_input_nombres")} <span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    {errors.nombre && errors.nombre.type === "required" && <p role="alert" className="error">{t("compra_envio_msg_nombre_requerido")}</p>}
                                </div>
                                <div className="col-6">
                                    <div className="form-floating">
                                        <input
                                            {...register("apellido", { required: true })}
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                        />
                                        <label>{t("compra_envio_input_apellidos")} <span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    {errors.apellido && errors.apellido.type === "required" && <p role="alert" className="error">{t("compra_envio_msg_apellido_requerido")}</p>}
                                </div>


                            </div>
                            <div className="row mt-2">
                                <div className="col-6">
                                    <div className="form-floating">
                                        <select {...register("pais", { required: true })} className="form-select">
                                            <option value="Peru">Perú</option>
                                        </select>
                                        <label>{t("compra_envio_select_pais")} <span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    {errors.pais && errors.pais.type === "required" && <p role="alert" className="error">{t("compra_envio_msg_pais_requerido")}</p>}
                                </div>
                                {
                                    watch("pais") === "Peru" ? (
                                        <div className="col-6">
                                            <AutoInput {...register('depProvDis', { required: true })} 
                                                data={listaUbigeo}
                                                placeholder={t("compra_envio_select_distrito")} 
                                                required={true} 
                                                saveData={(value) => { setValue('depProvDis', value) }}
                                            />
                                            {errors.depProvDis && errors.depProvDis.type === "required" && <p role="alert" className="error">{t("compra_envio_msg_distrito_requerido")}</p>}
                                        </div>
                                    ) : (
                                        <div className="col-6">
                                            <div className="form-floating">
                                                <input
                                                    {...register("ciudad", { required: true })}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                />
                                                <label>{t("compra_envio_input_ciudad")} <span style={{ color: "red" }}>*</span></label>
                                            </div>
                                            {errors.ciudad && errors.ciudad.type === "required" && <p role="alert" className="error">{t("compra_envio_msg_ciudad_requerido")}</p>}
                                        </div>
                                    )
                                }
                            </div>

                            <div className="row mt-2">
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input
                                            {...register("direccion", { required: true })}
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                        />
                                        <label>{t("compra_envio_input_direccion")} <span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    {errors.direccion && errors.direccion.type === "required" && <p role="alert" className="error">{t("compra_envio_msg_direccion_requerido")}</p>}
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-6">
                                    <div className="form-floating">
                                        <input
                                            {...register("telefono", { required: true })}
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                        />
                                        <label>{t("compra_envio_input_telefono")} <span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    {errors.telefono && errors.telefono.type === "required" && <p role="alert" className="error">{t("compra_envio_msg_telefono_requerido")}</p>}
                                </div>
                                <div className="col-6">
                                    <div className="form-floating">
                                        <input
                                            {...register("cod_postal")}
                                            type="text"
                                            className="form-control"
                                            placeholder="Codigo Postal"
                                        />
                                        <label >{t("compra_envio_input_postal")}</label>
                                    </div>
                                </div>
                            </div>

                            <div className="section-header mt-4">
                                <h2>{t("compra_combrobante_cabecera")}</h2>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="form-floating">
                                        <select className="form-select" {...register("comprobante.tipo", { required: true })}>
                                            <option value="">{t("compra_comprobante_select_tipo_option0")}</option>
                                            <option value="B">{t("compra_comprobante_select_tipo_option1")}</option>
                                            <option value="F">{t("compra_comprobante_select_tipo_option2")}</option>
                                        </select>
                                        <label className="form-label">{t("compra_comprobante_select_tipo")} <span style={{ color: "red" }}>*</span></label>
                                    </div>
                                    {errors.comprobante?.tipo && errors.comprobante?.tipo?.type === "required" && <p role="alert" className="error">{t("compra_comprobante_msg_tipo_requerido")}</p>}
                                </div>
                            </div>


                            {watch("comprobante.tipo") === 'B' && <>
                                <div className="row mt-2">
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <select className="form-select" {...register("comprobante.documento", { required: true })}>
                                                <option value="">{t("compra_comprobante_select_documento_option0")}</option>
                                                <option value="D">{t("compra_comprobante_select_documento_option1")}</option>
                                                <option value="CE">{t("compra_comprobante_select_documento_option2")}</option>
                                            </select>
                                            <label className="form-label">{t("compra_comprobante_select_documento")} <span style={{ color: "red" }}>*</span></label>
                                        </div>
                                        {errors.comprobante?.documento && errors?.comprobante?.documento?.type === "required" && <p role="alert" className="error">{t("compra_comprobante_msg_documento_requerido")}</p>}
                                    </div>
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <input
                                                {...register("comprobante.nroDocumento", { required: true, validate: handleIdNumberValidation })}
                                                type="text"
                                                className="form-control form-control-sm input-form"
                                            />
                                            <label className="form-label">{t("compra_comprobante_input_nro_documento")} <span style={{ color: "red" }}>*</span></label>
                                        </div>
                                        {errors.comprobante?.nroDocumento && errors?.comprobante?.nroDocumento?.type === "required" && <p role="alert" className="error">{t("compra_comprobante_msg_nro_documento_requerido")}</p>}
                                        {errors.comprobante?.nroDocumento && errors?.comprobante?.nroDocumento?.type === "validate" && <p role="alert" className="error">{t("compra_comprobante_msg_nro_documento_error")}</p>}
                                    </div>
                                </div>

                                <div className="row mt-2">
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <input
                                                {...register("comprobante.nombre", { required: true })}
                                                type="text"
                                                className="form-control form-control-sm input-form"
                                            />
                                            <label className="form-label">{t("compra_comprobante_input_nombres")} <span style={{ color: "red" }}>*</span></label>
                                        </div>
                                        {errors.comprobante?.nombre && errors?.comprobante?.nombre?.type === "required" && <p role="alert" className="error">{t("compra_comprobante_msg_nombre_requerido")}</p>}
                                    </div>
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <input
                                                {...register("comprobante.apellido", { required: true })}
                                                type="text"
                                                className="form-control form-control-sm input-form"
                                            />
                                            <label className="form-label">{t("compra_comprobante_input_apellido")} <span style={{ color: "red" }}>*</span></label>
                                        </div>
                                        {errors.comprobante?.apellido && errors?.comprobante?.apellido?.type === "required" && <p role="alert" className="error">{t("compra_comprobante_msg_apellido_requerido")}</p>}
                                    </div>
                                </div>



                            </>}

                            {watch("comprobante.tipo") === "F" && <>
                                <div className="row mt-2">
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <input
                                                {...register("comprobante.ruc", { required: true, validate: handleIdNumberValidation })}
                                                type="text"
                                                className="form-control form-control-sm input-form"
                                            />
                                            <label className="form-label">{t("compra_comprobante_input_ruc")} <span style={{ color: "red" }}>*</span></label>
                                        </div>
                                        {errors.comprobante?.ruc && errors?.comprobante?.ruc?.type === "required" && <p role="alert" className="error">{t("compra_comprobante_msg_ruc_requerido")}</p>}
                                        {errors.comprobante?.ruc && errors?.comprobante?.ruc?.type === "validate" && <p role="alert" className="error">{t("compra_comprobante_msg_ruc_error")}</p>}
                                    </div>
                                    <div className="col-6">
                                        <div className="form-floating">
                                            <input
                                                {...register("comprobante.razon", { required: true })}
                                                type="text"
                                                className="form-control form-control-sm input-form"
                                            />
                                            <label className="form-label">{t("compra_comprobante_input_razon")} <span style={{ color: "red" }}>*</span></label>
                                        </div>
                                        {errors.comprobante?.razon && errors?.comprobante?.razon?.type === "required" && <p role="alert" className="error">{t("compra_comprobante_msg_razon_requerido")}</p>}
                                    </div>
                                </div>
                            </>}

                        </form>
                        <div className="d-flex justify-content-center mt-3 mb-4">
                            <button
                                type="button submit"
                                onClick={handleSubmit(onSubmitDetalles)}
                                className="btn btn-primario w-100 text-white"
                                style={{ cursor: 'pointer' }}
                                disabled={carrito?.length > 0 ? false : true}
                            >
                                {t("compra_boton_continuar")}
                                {
                                    loading && (
                                        <div className="spinner-border text-light spinner-border-sm" role="status">
                                            <span className="visually-hidden" >Loading...</span>
                                        </div>
                                    )
                                }

                            </button>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="mt-4 floating-card bg-secundario pt-4 pb-4">
                            <h4 style={{fontFamily:"var(--font-family-headers)", color:"var(--color-terciario)"}}>{t("compra_resumen_cabecera")}</h4>
                            <div style={{width:'max-content'}}>
                                <span onClick={()=>{navigate('/carrito')}} className="link-deco" style={{cursor:'pointer'}}>{t("compra_resumen_btn_editar")}</span>                                
                            </div>

                            <div className="compra-carrito">
                            {carrito?.length > 0 ? (
                                <div>
                                    <div className="cart-content compra">
                                    {carrito.length > 0 && carrito.map((c) => (
                                        <div className="cart-box" key={c?.ProdCod}>
                                            <div className="bg-image-cart border border-1 rounded-2">
                                                <img src={c?.ProdImg} alt="..." className="cart-img" />
                                            </div>

                                            <div className="detail-box">
                                                <div className="cart-product-title">{c?.ProdNom}</div>
                                                <div className="d-flex justify-content-between">
                                                    <div className="cart-price">
                                                        {
                                                            (!c?.ProdPrecD) ? (
                                                                <span>{formatter.format(c?.ProdPrecN)}</span>
                                                            ) : (
                                                                <>
                                                                    <s style={{ fontSize: "14px", color: "rgb(128,128,128)" }}>{formatter.format(c?.ProdPrecN)}</s>
                                                                    <span className="ms-2">{formatter.format(c?.ProdPrecD)}</span>
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="numero">{t("compra_resumen_cantidad")}: <span>{c?.Cantidad}</span></div>
                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                    </div>

                                    <div className="total">
                                        <div className="total-title">{t("compra_resumen_total")}</div>
                                        <div className="total-price">{totalCarrito()}</div>
                                    </div>
                                </div>
                                ) : (
                                    <Link className="nav-link text-center mt-5" to="/tienda">
                                        {t("tienda_carrito_btn_añadir")}
                                    </Link>
                                )
                            }
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme={tema}
            />
        </div>
    )
}
